import { useState } from 'react';

/** As mesmas opções de itens por página das outras listas do sistema. */
const OPCOES_POR_PAGINA: readonly number[] = [10, 25, 50, 100];

/**
 * A página de uma lista da administração da plataforma, para o rodapé da
 * tabela (p.18): "Mostrando 1–10 de 42" à esquerda, paginação ao centro e
 * itens por página à direita. Devolve a fatia visível e as propriedades do
 * `RodapeTabela`, prontas para espalhar.
 *
 * O estado mora na tela, e não na URL: a URL da plataforma guarda a seção e a
 * empresa abertas, que é o que se manda para alguém; a página da lista não é.
 */
export function usePaginacao<T>(linhas: readonly T[]) {
  const [pagina, setPagina] = useState(1);
  const [porPagina, setPorPagina] = useState(OPCOES_POR_PAGINA[0] ?? 10);

  const paginas = Math.max(Math.ceil(linhas.length / porPagina), 1);
  const atual = Math.min(pagina, paginas);
  const inicio = (atual - 1) * porPagina;
  const visiveis = linhas.slice(inicio, inicio + porPagina);

  return {
    visiveis,
    rodape: {
      primeiro: inicio + 1,
      ultimo: inicio + visiveis.length,
      total: linhas.length,
      pagina: atual,
      paginas,
      porPagina,
      opcoesPorPagina: OPCOES_POR_PAGINA,
      aoMudarPagina: setPagina,
      aoMudarPorPagina: (novo: number) => {
        setPorPagina(novo);
        setPagina(1);
      },
    },
  };
}
